import pathfinder from '../assets/images/pathfinder.jpg';
import news from '../assets/images/news.JPG';
import background1 from '../assets/images/fresh-snow.png';
import background2 from '../assets/images/large-leather-1920x1080.png';
import background3 from '../assets/images/light-honeycomb--dark--1920x1080.png';
import background4 from '../assets/images/scribble-light-1920x1080.png';
import background5 from '../assets/images/background5.png';
import news1 from '../assets/images/news-img1.png';
import news2 from '../assets/images/news-img2.png';
import news3 from '../assets/images/news-img3.png';
import news4 from '../assets/images/news-img4.PNG';
import vapour from '../assets/images/vapour.png';
import vapour1 from '../assets/images/vapour-img1.png';
import vapour2 from '../assets/images/vapour-img2.png';
import vapour3 from '../assets/images/vapour-img3.jpg';
import vapour6 from '../assets/images/vapour-img6.png';
import vapour7 from '../assets/images/vapour-img7.png';
import fractal from '../assets/images/fractal-tree.JPG';
import kaleid from '../assets/images/kaleid.PNG';
import React from 'react'
const items = [
  {
    id: 0,
    desktop: true,
    title: 'Vapour',
    description: 'Vapour is a social gaming platform where users can play games and chat with each other',
    imgSrc: vapour,
    gitLink: 'https://github.com/David-Beale/Vapour-backend',
    link: 'https://vapour.netlify.com/',
    color: 'aliceblue',
    background: background1,
    readMore: (
      <div>
        <p>This is a 2 week group project where we built a full stack social gaming platform on which users can play games and chat with each other.</p>
        <h3>Features</h3>
        <h5>Multiplayer Games</h5>
        <img src={vapour2} alt='vapour2' className="read-more-image"></img>
        <p>The first game is inspired by Agario and Asteroids. It is a free for all multiplayer game using SocketIO. Players can eat the green food to gain mass and ammo.
        Players can shoot opponents or eat them if they are bigger than them. Getting hit reduces your size and you will die if you get too small.
        Player names and images are downloaded from Vapour's database.
        </p>
        <img src={vapour3} alt='vapour3' className="read-more-image"></img>
        <p>The second game is a classic game of Pong. It is a 1v1 game using SocketIO but more players can spectate and join a queue. The loser will be sent to the back of the queue and the winner keeps playing.
        Player names and images are downloaded from Vapour's database.
        </p>
        <p>The platform also has 2 single player games: Snake and a side scroller.
        </p>
        <h5>Chat</h5>
        <img src={vapour6} alt='vapour6' className="read-more-image"></img>
        <p>The platform features a chat section where users can chat with other online users. Messages are sent using SocketIO and stored in the database for future sessions.
        </p>
        <h5>Chat rooms</h5>
        <img src={vapour7} alt='vapour7' className="read-more-image"></img>
        <p>There are also several chat rooms where users can discuss topics with everyone else in the room.
        </p>
        <h5>Facial recognition</h5>
        <p>The profile section allows users to submit a profile image using their webcam or via file upload. FaceAPI is used to detect a face, which is then cropped and stored on the database.
        </p>
        <h5>Vapour effect</h5>
        <p>The background canvas uses fluid dynamics algorithms to display a vapour style effect.
        </p>
        <h3>Tech Stack</h3>
        <ul>
          <li>
            React
          </li>
          <li>
            Redux
          </li>
          <li>
            Express
          </li>
          <li>
            SocketIO
          </li>
          <li>
            MongoDB
          </li>
          <li>
            Passport
          </li>
          <li>
            p5.js
          </li>
          <li>
            faceAPI
          </li>
        </ul>
      </div>)
  },
  {
    id: 1,
    desktop: true,
    title: 'Pathfinder',
    description: `Pathfinder is an interactive visualisation of Dijkstra's pathfinding algorithm. The algorithm can determine the shortest route or predict the fastest route based on real time traffic data.`,
    imgSrc: pathfinder,
    gitLink: 'https://github.com/David-Beale/Pathfinding-project',
    link: 'https://david-beale.github.io/Pathfinding-project/',
    // color:'rgba(81, 94, 112, 0.562)',//rgb(235, 155, 135)
    color: 'aliceblue',//rgb(235, 155, 135)
    background: background3,
    readMore: (
      <div>
        <p>This is my 1 week solo project which is based on Dijkstra's algorithm. The purpose of the project was to visualise the pathfinding algorithm in real-time and make the application interactive and user-friendly. I used this an opportunity to apply the knowledge I gained so far and challenge myself to develop a functional program without any step by step tutorials/guides.</p>
        <h3>How to use it</h3>
        <h5>There is a tips icon which gives the user some basic instructions:</h5>
        <ul>
          <li>Right click the map to select a point and to move the user vehicle.</li>
          <li>Left click and drag to move the map.</li>
          <li>Use the scroll wheel to zoom in and out.</li>
        </ul>
        <h5>Main buttons:</h5>
        <ul>
          <li>Clicking "shortest distance" or "fastest time" will set the default pathfinding algorithm.</li>
          <li>Clicking "compare" allows the user to compare the 2 algorithms. Differences will only arise when congestion occurs.</li>
        </ul>
        <h5>Click the menu item to access additional features:</h5>
        <ul>
          <li>Start/stop will pause the program.</li>
          <li>Toggle functional traffic lights on/off.</li>
          <li>Toggle camera lock will center the camera on the vehicle.</li>
          <li>Toggle collision boxes/traffic visuals display some of the inner workings of the app.</li>
          <li>Add/remove roadworks limits the speed of all vehicles.</li>
          <li>Speed sliders will adjust the vehicle speeds.</li>
          <li>Enter number of computer cars to populate the map. Note: Performance issues arise when this number gets too high (over 1000).</li>
        </ul>
        <h3>Features</h3>
        <ul>
          <li>
            Distance based pathfinding will determine the shortest route to the destination.
          </li>
          <li>
            Time based pathfinding estimates the quickest route based on data gathered from other vehicles.
          </li>
          <li>
            Comparison function will display the two routes, as well as total distance and the estimated time for each path.
          </li>
          <li>
            Curved trajectories - the user vehicle will follow a curved trajectory when turning. I tried implementing this feature for all vehicles; however, the simplistic pathfinding of these vehicles resulted in a high probability of irreversible gridlock at junctions.
          </li>
          <li>
            Traffic lights - vehicles will stop and queue when the light is red or yellow and will continue on green lights.
          </li>
          <li>
            Collision prevention - vehicles will stop when the vehicle in front stops. They will also slow down when the vehicle in front slows down, or when road conditions require it.
          </li>
          <li>
            In transit destination change - the user can change the destination while the vehicle is still en route to another destination. The vehicle will calculate and store the new path, and when the vehicle has reached the next vertex, this path will be loaded and followed.
          </li>
          <li>
            Camera - the user can manipulate the camera view by dragging the map around, or zooming in and out. The user can also lock the camera onto the vehicle, and will follow it until it is disabled.
          </li>
          <li>
            Visual click feedback - a pulse is created when the user right clicks on the road.
          </li>
        </ul>
        <h3>Tech Stack</h3>
        <ul>
          <li>
            HTML
          </li>
          <li>
            HTML Canvas (no additional libraries)
          </li>
          <li>
            Javascript
          </li>
          <li>
            CSS
          </li>
          <li>
            JQuery
          </li>
        </ul>
      </div>)
  },
  {
    id: 2,
    desktop: true,
    title: 'News Feeds',
    description: 'News Feeds helps users to create their own feeds by selecting text and/or image to scrape from any website. The app will scrape the site once an hour and store any new data for the user to view.',
    imgSrc: news,
    gitLink: 'https://github.com/David-Beale/News-scraper-frontendV2',
    link: 'https://db-newsfeeds.netlify.com/',
    color: 'aliceblue',
    background: background2,
    readMore: (
      <div>
        <p>News Feeds helps users to create their own feeds by selecting text and/or images to scrape from any website. The app will scrape the site once an hour and store any new data for the user to view.</p>
        <h3>Features</h3>
        <h5>Add custom feed</h5>
        <img src={news3} alt='news 3' className="read-more-image"></img>
        <p>Clicking add feed will allow the user to view an external website within the app. The draggable widget will allow the user to select a title, summary, image and link by clicking the desired content on the page.
        The scraping algorithm will save a unique path to the content which will be used each time the server scrapes the content.
          The "Not what you are looking for" button will try to access surrounding content and will give users the available options to choose from.</p>
        <h5>Calendar select</h5>
        <img src={news1} alt='news 1' className="read-more-image"></img>
        <p>Browse previously scraped headlines by date using the calendar select tool.</p>
        <h5>Authentication</h5>
        <img src={news4} alt='news 4' className="read-more-image"></img>
        <p>Authentication allows users to control their own content which will only be accessible to their account.</p>
        <h5>Delete headlines</h5>
        <img src={news2} alt='news 2' className="read-more-image"></img>
        <p>Delete headlines will delete the current headline stored in the database. It will reappear if it is scraped again in the next cycle.
          Delete scraper will stop the app from scraping this headline in the future.</p>
        <h5>Observations</h5>
        <ul>
          <li>
            All external scripts are disabled when viewing external sites. Therefore, websites which rely heavily on scripts will not display properly. However, any visible content can still be scraped even if the formatting is broken.
          </li>
          <li>
            The custom scraping algorithm relies on the stored path to the content. Changes to the external site may cause the path to break, resulting in scrape failures.
          </li>
          <li>
            Certain sites including BBC News employ anti-scraping measures which prevent the app from scraping the content correctly.
          </li>
          <li>
            The site is for educational purposes only and is not intended as a commercial product.
          </li>
        </ul>
        <h3>Tech Stack</h3>
        <ul>
          <li>
            React
          </li>
          <li>
            Express
          </li>
          <li>
            Apollo
          </li>
          <li>
            MongoDB
          </li>
          <li>
            GraphQL
          </li>
          <li>
            Passport
          </li>
        </ul>
      </div>)
  },
  {
    id: 3,
    desktop: true,
    title: 'Fractal Tree',
    description: 'A small project that produces a randomly generated tree with flowers and leaves',
    imgSrc: fractal,
    gitLink: 'https://github.com/David-Beale/fractal-tree',
    link: 'https://david-beale.github.io/fractal-tree/',
    color: 'aliceblue',
    background: background4,
    readMore: (
      <div>
        <ul>
          <li>A small project that produces a randomly generated tree with flowers and leaves</li>
          <li>Branches are created with random angles and lengths</li>
          <li>Flowers are grown to a random size then fall with a random windspeed and rotation</li>
          <li>Leaves are grown with a random arrangement</li>
        </ul>
      </div>)
  },
  {
    id: 4,
    desktop: false,
    title: 'Kaleidoscope',
    description: 'A small project that lets you draw geometric patterns',
    imgSrc: kaleid,
    gitLink: 'https://github.com/David-Beale/kaleidoscope',
    link: 'https://david-beale.github.io/kaleidoscope/',
    color: 'aliceblue',
    background: background5,
    readMore: (
      <div>
        <ul>
          <li>A small project that lets you draw geometric patterns.</li>
          <li>The app uses the mouse speed to determine the stroke thickness. Linear interpolation is used to smooth out sharp changes in speed.</li>
        </ul>
      </div>)
  },

]
export default items